const modal = {
  cancelButton: 'התעלם',
  confirmButton: 'אשר',
  confirmChange: {
    title: 'אישור שינוי',
    body: 'האם אתה בטוח שברצונך לבצע שינוי זה?',
    confirmButton: 'אישור',
    cancelButton: 'ביטול',
    verificationPlaceholder: 'הכנס את ביטוי האימות',
  },
};

export default modal;
